export const environment = {
  production: false,
  baseUrl: 'https://api-sandbox.payee.tech/payment',

  HELP_URL: 'https://help.payee.tech/hu/',
};
